export const getProdEnv = () => {
    const _origin = location.origin;
    if (_origin.includes('.cc')) return 'develop';
    else if (_origin.includes('.xyz')) return 'staging';
    else if (_origin.includes('.cn')) return 'release';
    else return 'develop'
}